/** @format */

export interface ShipModeInformation {
  estimate_delivery: ShipModeInformationEDD;
}

export interface ShipModeInformationEDD {
  date: string;
}

export interface Information {
  estimated_delivery: EstimatedDelivery;
}

export interface EstimatedDelivery {
  external_source?: string;
  groups: ShippingGroup[];
}
export interface ShippingGroup {
  edd_skus: EDDSku[];
  group_number: number;
}

export interface EDDSku {
  dates: string[];
  sku: string;
}

export interface DeliveryDates {
  promise_end_edd_date: string;
  promise_start_edd_date?: string;
  shipping_mode_service_level: string;
}
export interface DeliveryList {
  estimated_delivery_list: DeliveryDates[];
  sku: string;
}
export interface CartEDD {
  analytics: any;
  dateTable: { [key: string]: string };
  sku_estimated_delivery_list: DeliveryList[];
}

export interface SkuDeliveryList {
  promise_end_edd_date?: string;
  promise_start_edd_date?: string;
  shipping_mode_service_level?: string;
}

export interface SkuDeliveryListV2 extends SkuDeliveryList {
  edd_service_level?: string;
  reason_codes?: ReasonCode[];
}

export interface CheckoutSkuEDD {
  estimated_delivery_list: SkuDeliveryList[];
  reason_codes?: string[];
  sku: string;
}

export interface ReasonCode {
  declaring_class?: string;
  default_text?: string;
  reason_code?: string;
}

export interface SkuEDDV2 {
  estimated_delivery_list: SkuDeliveryListV2[];
  sku: string;
}

export interface EDDv2 {
  analytics?: string;
  sku_estimated_delivery_list: SkuEDDV2[];
}

export interface ModernReasonCode {
  defaultText: string;
  reasonCode: string;
}
export interface ModernEstimatedDeliveryList {
  eddServiceLevel: string;
  promiseEndEddDate: string;
  promiseStartEddDate: string;
  reasonCodes: ModernReasonCode[];
  shippingModeServiceLevel: string;
}

export interface ModernSkuDeliveryList {
  estimatedDeliveryList: ModernEstimatedDeliveryList[];
  sku: string;
}
export interface ModernEDD {
  analytics: string;
  skuEstimatedDeliveryList: ModernSkuDeliveryList[];
}
